import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import {AppSettings} from '../../app-settings';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {IMyDpOptions, IMyDate , IMyDateModel,IMyInputFieldChanged} from 'mydatepicker';
import { Router} from '@angular/router';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {Location, LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-extendCourse',
  templateUrl: './extend-course.component.html',
  styleUrls: ['./extend-course.component.css']
})
export class extendCourseComponent implements OnInit {
  formValid:boolean=false;
  extendCourseValid:boolean = false;
  yesNoValidity:boolean = false;
  enterDetailsValidity:boolean = false;
  courseList:Array<any>;
  repuchaseList:Array<any>;
  active:boolean=false;
  choiceListActive:boolean = false;
  gmatDate:Date;
  date = new Date();
  courseHasDate:boolean=true;
  dateplaceHolder = "Select the Date";
  dateplcaeHolderNo = "Select the Date";
  userChoice:string="";
  packageCourseName:string="";
  gmatProof:any;
  packageData: object = {};
  defaultChoice:string="Select the Course";
  subscriptionList:Array<any>;
  declarationInput:boolean=false;
  repurchaseWizard:boolean=false;
  dateInput:boolean;
  extensionPrice:any;
  actualPrice:any;
  refundPrice:any;
  extensionPeriod:any;
  extensionLink:any;
  chargeDetails:boolean=false; 
  dateInvalid:boolean=true;
  hasDate:boolean=false;
  btnCaption:string="Upload";
  popup:string="";
  status:boolean=false;
  proofAttach:boolean=true;
  askGMATDate=["Yes","No"];
  formData:FormData;
  dateSelected:boolean = false;
  imageUploaded:boolean = false;
  yesNotext:string = "Yes/No";
  userNoDateSelected:boolean = false;
  userNoExtendValidity:boolean = false;
  userYesExtendValidity:boolean = false;
  courseListLoaded:boolean = false;
  extensionNoDataLoaded:boolean = false;
  extensionYesDataLoaded:boolean = false;
  rePurchaseDataLoaded:boolean = false;
  listRepurchaseErrorMessage:string;
  isListRepurchaseError:boolean = false;
  isUpdatePackageErrorNo:boolean = false;
  updatepackageErrorMessageNo:string;
  isUpdatePackageErrorYes:boolean = false;
  updatepackageErrorMessageYes:string;
  listWaiting:string = AppSettings.cdnUrl+"assets/images/list_waiting.gif";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  closeImage:string = AppSettings.cdnUrl+"assets/images/close.png";
  gmatScreenShotImg= AppSettings.cdnUrl+"assets/images/GMAT-screenshot.png";
  isExtensionListError:boolean = false;
  faqImage3:string = AppSettings.cdnUrl+"assets/images/faq_3.png";
  faqImage4:string = AppSettings.cdnUrl+"assets/images/faq_4.png";
  redirectImg = AppSettings.cdnUrl+"assets/images/blocks_redirect.gif";
  extensionListError:string;
  uploadedImageName:string;
  redirectMsg:string = '';
  redirectToCart:boolean = false;
  dateYes:any;
  dateNo:any;
  packageId:number;
  proofGMATYes:any;
  proofGMATNo:any = null;
  public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd-mmm-yyyy',
        showTodayBtn:false,
        sunHighlight:false,
        editableDateField:false,
        disableUntil:{year: this.date.getFullYear(),
            month: this.date.getMonth()+1,
            day: this.date.getDate()},
            disableSince:{year: this.date.getFullYear(),
            month: this.date.getMonth(),
            day: this.date.getDate() + 217}, 
            ariaLabelInputField:'Select the Date',
            alignSelectorRight:true,
            openSelectorOnInputClick:true
  };
 expand:string=AppSettings.cdnUrl+"assets/images/expandArrow.png";
 collapse:string=AppSettings.cdnUrl+"assets/images/collapse.png";
  constructor(private formBuilder:FormBuilder,private httpClientService: HttpClientService , private sanitizer: DomSanitizer,private router:Router,private readonly location: Location) 
 {
    this.formData = new FormData();
    /*this.formValid=formBuilder.group({
      //'selectCourse':['Select the course',Validators.required]
    });*/
    //this.courseList=[{id:1, name:"GMAT Live Prep"},{id:2, name:"GMAT Online" },{id:3, name:"Verbal Online" }];

}
//get selectCourse(){return this.formValid.get('selectCourse');}

  ngOnInit() 
  {
    console.log('extend component');
    console.log(this.courseList);
    //eligible package list
    this.httpClientService.get(AppSettings.restApiUrl + '/api/package/extension/list',new HttpHeaders()).subscribe((data)=>{
    this.courseList = data.packageList;
    if(this.courseList.length==0 || Object.keys(data.defaultPackage).length == 0)
    {
    this.httpClientService.get(AppSettings.restApiUrl + '/api/package/repurchase/list',new HttpHeaders()).subscribe((data)=>{
    this.repuchaseList = data;
    this.courseListLoaded = true;
    },
    (e)=>{
        if(e.status != 401 && e.status != 410)
        {
          this.courseListLoaded = true;
        }
        this.listRepurchaseErrorMessage = e.message;
        this.isListRepurchaseError = true;

    });  
    this.repurchaseWizard=true;
    }
    else
    {
      if(data.defaultPackage.name != null && data.defaultPackage.name!= '' && data.defaultPackage.name != undefined)
      {
        this.defaultChoice=data.defaultPackage.name;
        this.packageCourseName = data.defaultPackage.name;
        this.extendCourseValid = true;
        this.packageId = data.defaultPackage.packageId;
        this.packageData["packageId"] = data.defaultPackage.packageId;
      }
      this.userChoice=this.defaultChoice;
      this.repurchaseWizard=false;
      this.courseListLoaded = true;
      //this.removeMultipleImageSelect();
     }
   },(e)=>
   {
      if(e.status != 401 && e.status != 410)
      {
        this.courseListLoaded = true;
      }
      this.isExtensionListError = true;
      this.extensionListError = e.message;

   });
    //subscription List
    this.httpClientService.get(AppSettings.restApiUrl + '/api/package/subscription/detail',new HttpHeaders()).subscribe((data)=>{
    this.subscriptionList = data;
    });
    console.log(this.courseList);
    //repurchase list---for now blank
  }

finishFunction(val){
  if(val == 'discount')
  {
    this.redirectMsg = 'Applying special discount based on GMAT Date and Redirecting to Shopping cart.';
  }
  else
  {
    this.redirectMsg = 'Redirecting to Shopping cart.'
  }
  this.redirectToCart = true;
  //window.location.href = this.extensionLink;
  setTimeout(()=>{window.location.href = this.extensionLink;},2000);
   /*this.router.navigateByUrl(this.extensionLink);*/
}
expandCourse(){
  if(!this.courseListLoaded)
  {
    return;
  }
  this.active=!this.active;
}
selectChoice()
{
  this.choiceListActive = !this.choiceListActive;
}
packageSelected(val,id)
{
this.packageCourseName=val;
this.defaultChoice = val;
this.active=!this.active;
this.packageId=id;
this.packageData["packageId"] = id;
//this.formData.append('packageId',id);
if(this.packageCourseName=="")
this.extendCourseValid=false;
else
this.extendCourseValid=true;
this.extensionNoDataLoaded = false;
this.extensionYesDataLoaded = false;
this.userNoExtendValidity = false;
if(this.userChoice=="")
this.yesNoValidity=false;
else
this.yesNoValidity=true;
}
packagePurchaseSelected(val, id)
{
  this.packageId=id;
  this.packageData["packageId"] = id;
  this.active=!this.active;
  this.rePurchaseDataLoaded = false;
  this.packageCourseName=val;
  this.defaultChoice = val;
  if(this.packageCourseName=="")
  this.extendCourseValid=false;
  else
  this.extendCourseValid=true;
}

choiceSelected(val){
this.userChoice=val;
this.yesNotext = val;
this.choiceListActive = !this.choiceListActive;
this.extensionNoDataLoaded = false;
this.extensionYesDataLoaded = false;
this.userNoExtendValidity = false;
if(this.userChoice=="")
this.yesNoValidity=false;
else
this.yesNoValidity=true;
}

repurchaseCourseSel(){
  const headers = new HttpHeaders();
      this.httpClientService.post(AppSettings.restApiUrl + '/api/package/repurchase/price', this.packageData, headers)
        .subscribe(
          (data) => {  
            this.extensionPrice=data.price.extensionPrice;
            this.extensionPeriod=data.price.extensionPeriod;
            this.extensionLink = data.extensionLink;
            this.rePurchaseDataLoaded = true;

          }, (e) => {
             this.rePurchaseDataLoaded = true;
          });
}

sendSelectedCourse(){
this.hasDate=true;
this.userChoice="";
this.yesNotext =  "Yes/No";
//this.extendCourseValid=false;
}
hideChoiceList(val)
{
  if(val == 'Yes' || val == 'hideList')
  {
    this.hasDate=false;
    setTimeout(()=>{this.removeImageMultipleUpload();},1000);
    
  }
  
}
goBack(){
  this.hasDate=false;
  //this.formValid=false;
}
sendCourseAndDate(){
this.formValid=false;
}

onDateChanged(event:any){
  this.gmatDate=event.formatted;
  this.dateplaceHolder = event.formatted;
  this.packageData["gmatDate"]=event.epoc*1000 + 86400000 - 1000;
  this.dateSelected = true;
  this.checkFormValidity();
}
onDateChangedNoSlected(event)
{
  /*this.packageData["gmatDate"]=event.epoc*1000 + 86400000 - 1000;
  this.packageData["gmatProof"]=null;*/
  this.userNoDateSelected = true;
  this.extensionNoDataLoaded = false;
  this.dateplcaeHolderNo = event.formatted;
  this.dateNo = event.epoc*1000 + 86400000 - 1000;
  let packageInfo = {};
  packageInfo["gmatDate"] = this.dateNo;
  packageInfo["packageId"] = this.packageId;
  packageInfo["gmatProof"] = null;
  this.extendNow(packageInfo);
}
onUploadFinished(event){
this.proofAttach=false;
this.btnCaption="File uploaded";
this.packageData["gmatProof"]={'type':event.file.type, 'name':event.file.name, 'size':event.file.size, 'content':event.src};
//document.querySelector('.img-ul span').className='imageUploaded';
//document.querySelector('.img-ul-upload').classList.add('backgroundUpdated');
this.imageUploaded = true;
this.uploadedImageName = event.file.name;
/*if(this.dateInvalid==true || this.declarationInput==false)  
this.formValid=false;
else
this.formValid=true;*/
this.checkFormValidity();
}
checkFormValidity()
{
  if(this.dateSelected && this.declarationInput && this.imageUploaded)
  {
     this.enterDetailsValidity = true;
     this.extensionYesDataLoaded = false;
  }
  else
  {
    this.enterDetailsValidity = false;
  }
}
goBackChoice(){
  //this.formValid=false;
  //this.hasDate=true;
  //this.userChoice='';
}
onInputFieldChanged(event:IMyInputFieldChanged){
if(this.userChoice=='Yes')
{
this.dateInput=event.valid;
if(this.dateInput==true)
{
/*this.dateInvalid=false;
if(this.proofAttach=true || this.declarationInput==false)  
this.formValid=false;
else
this.formValid=true;*/
//this.checkFormValidity();
}
}
else if(this.userChoice=='No')
{
 /*if(this.dateInput==true)
   {
this.packageData["gmatProof"]=null;
this.extendNow();
  this.chargeDetails=true;
  this.formValid=true;

}
  else
   {this.formValid=false;this.chargeDetails=false;}*/
}
}
pauseVideo()
{
  let vid = <HTMLVideoElement>(document.getElementById("extVideo")); 
  vid.pause(); 
}
extendNow(packageDataAll){
  let x = this.packageData;
const headers = new HttpHeaders();
      this.httpClientService.post(AppSettings.restApiUrl + '/api/user/gmat/update', packageDataAll, headers)
        .subscribe(
          (data) => { 
            this.extensionPrice=data.price.extensionPrice;
            this.actualPrice=data.price.actualPrice;
            this.refundPrice=data.price.refundPrice;
            this.extensionPeriod=data.price.extensionPeriod;
            if(this.extensionPeriod !=null && this.extensionPeriod!='')
            {
              this.extensionPeriod=this.extensionPeriod.trim();
            }
            this.extensionLink = data.extensionLink;
            if(this.userChoice === 'Yes')
            {
              this.extensionYesDataLoaded = true;
              this.userYesExtendValidity = true;
              this.isUpdatePackageErrorYes = false;
            }
            else if(this.userChoice === 'No')
            {
               this.extensionNoDataLoaded = true;
               this.userNoExtendValidity = true;
               this.isUpdatePackageErrorNo = false;
            }
            

          }, (e) => 
          {
            if(this.userChoice === 'Yes')
            {
              this.extensionYesDataLoaded = true;
              this.userYesExtendValidity = false;
              this.isUpdatePackageErrorYes = true;
              this.updatepackageErrorMessageYes = e.message;
            }
            else if(this.userChoice === 'No')
            {
               this.extensionNoDataLoaded = true;
               this.userNoExtendValidity = false;
               this.isUpdatePackageErrorNo = true;
               this.updatepackageErrorMessageNo = e.message;
            }
            
            if(!(this.packageData["gmatProof"].type == 'image/png' || this.packageData["gmatProof"].type == 'image/jpeg'))
            {
              this.updatepackageErrorMessageYes = "Unsupported Image format";
            }
          });

}
loadDataforCourse()
{
  if(!this.userNoExtendValidity && this.userNoDateSelected)
  {
    let packageInfo = {};
    packageInfo["gmatDate"] = this.dateNo;
    packageInfo["packageId"] = this.packageId;
    packageInfo["gmatProof"] = null;
    this.extendNow(packageInfo);
  }
}
showPopup(val){
  this.status=true; 
  this.popup=val;
  document.body.classList.add('coursePopIn');
}
close(){
 this.status=false; 
 document.body.classList.remove('coursePopIn');
}
declineDeclaration()
{
  this.declarationInput=false;
 this.status=false;
 this.checkFormValidity();
 document.body.classList.remove('coursePopIn');
}

acceptDeclaration(){
 this.declarationInput=true;
 this.status=false;
 this.checkFormValidity();
 document.body.classList.remove('coursePopIn');
}
removeImageMultipleUpload()
{

  let imageInput = document.getElementsByClassName('img-ul-upload')[0];
  if(imageInput)
  {  
    if(imageInput.getElementsByTagName('input'))
    {
      (<HTMLInputElement>imageInput.getElementsByTagName('input')[0]).removeAttribute('multiple');
    }
  }
}
}
